import _ from "lodash";
import { PROVIDER_CONNECTION_TYPE, PROVIDER_FIELDS } from "./constants";
import { queryWaterProviderWithDocs } from "./api";
import { QUERY_URL_AND } from "./constants";
import { WaterProvider } from "./types";

export const fetchProviderByGeometry = async (lon: number, lat: number): Promise<WaterProvider[]> => {
    const geoQuery = `q={!field f=geojsons_geometry} Intersects({"type":"Point","coordinates":[${lon}, ${lat}]})`;
    const fieldQuery = `fq=pure_strings_connection_size_ct: (NOT "${PROVIDER_CONNECTION_TYPE.bulk}")`;

    const solrQuery = _.join([geoQuery, "rows=1", fieldQuery, `fl=${PROVIDER_FIELDS}`], QUERY_URL_AND);

    return queryWaterProviderWithDocs(solrQuery);
};
